import { render, staticRenderFns } from "./CymaLayout.vue?vue&type=template&id=37819a52"
import script from "./CymaLayout.vue?vue&type=script&lang=js"
export * from "./CymaLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports